import pkg from './../package.json';

const Config={
    basename:pkg.basename,
    homepage:pkg.homepage,
    strapi_url:pkg.api_url,
}
export default Config;